"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrefKey = void 0;
var PrefKey;
(function (PrefKey) {
    PrefKey["TagsPanelWidth"] = "tagsPanelWidth";
    PrefKey["NotesPanelWidth"] = "notesPanelWidth";
    PrefKey["EditorWidth"] = "editorWidth";
    PrefKey["EditorLeft"] = "editorLeft";
    PrefKey["EditorSpellcheck"] = "spellcheck";
    PrefKey["EditorResizersEnabled"] = "marginResizersEnabled";
    PrefKey["SortNotesBy"] = "sortBy";
    PrefKey["SortNotesReverse"] = "sortReverse";
    PrefKey["NotesShowArchived"] = "showArchived";
    PrefKey["NotesShowTrashed"] = "showTrashed";
    PrefKey["NotesHideProtected"] = "hideProtected";
    PrefKey["NotesHidePinned"] = "hidePinned";
    PrefKey["NotesHideNotePreview"] = "hideNotePreview";
    PrefKey["NotesHideDate"] = "hideDate";
    PrefKey["NotesHideTags"] = "hideTags";
    PrefKey["NotesHideEditorIcon"] = "hideEditorIcon";
    PrefKey["NoteAddToParentFolders"] = "noteAddToParentFolders";
    PrefKey["NewNoteTitleFormat"] = "newNoteTitleFormat";
    PrefKey["CustomNoteTitleFormat"] = "customNoteTitleFormat";
    PrefKey["UpdateSavingStatusIndicator"] = "updateSavingStatusIndicator";
    PrefKey["DefaultEditorIdentifier"] = "defaultEditorIdentifier";
    PrefKey["MomentsDefaultTagUuid"] = "momentsDefaultTagUuid";
    PrefKey["ClipperDefaultTagUuid"] = "clipperDefaultTagUuid";
    PrefKey["SystemViewPreferences"] = "systemViewPreferences";
    PrefKey["SuperNoteExportFormat"] = "superNoteExportFormat";
    PrefKey["SuperNoteExportEmbedBehavior"] = "superNoteExportEmbedBehavior";
    PrefKey["SuperNoteExportUseMDFrontmatter"] = "superNoteExportUseMDFrontmatter";
    PrefKey["SuperNoteExportPDFPageSize"] = "superNoteExportPDFPageSize";
    PrefKey["SuperNoteImageAlignment"] = "superNoteImageAlignment";
    PrefKey["AuthenticatorNames"] = "authenticatorNames";
    PrefKey["PaneGesturesEnabled"] = "paneGesturesEnabled";
    PrefKey["ComponentPreferences"] = "componentPreferences";
    PrefKey["ActiveComponents"] = "activeComponents";
    PrefKey["AlwaysShowSuperToolbar"] = "alwaysShowSuperToolbar";
    PrefKey["AddImportsToTag"] = "addImportsToTag";
    PrefKey["AlwaysCreateNewTagForImports"] = "alwaysCreateNewTagForImports";
    PrefKey["ExistingTagForImports"] = "existingTagForImports";
    PrefKey["Locale"] = "locale";
    PrefKey["HasSeenLocalizationLabsSpotlight"] = "hasSeenLocalizationLabsSpotlight";
    PrefKey["DEPRECATED_ActiveThemes"] = "activeThemes";
    PrefKey["DEPRECATED_UseSystemColorScheme"] = "useSystemColorScheme";
    PrefKey["DEPRECATED_UseTranslucentUI"] = "useTranslucentUI";
    PrefKey["DEPRECATED_AutoLightThemeIdentifier"] = "autoLightThemeIdentifier";
    PrefKey["DEPRECATED_AutoDarkThemeIdentifier"] = "autoDarkThemeIdentifier";
    PrefKey["DEPRECATED_EditorMonospaceEnabled"] = "monospaceFont";
    PrefKey["DEPRECATED_EditorLineHeight"] = "editorLineHeight";
    PrefKey["DEPRECATED_EditorLineWidth"] = "editorLineWidth";
    PrefKey["DEPRECATED_EditorFontSize"] = "editorFontSize";
})(PrefKey || (exports.PrefKey = PrefKey = {}));
